<template>
 
  <div>
    
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  export default {
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*背景图片*/
        bgimg_url: '',
        /*是否正在提交*/
        logining: false,
        /*基础配置*/
        baseData: {},
        banner: 0,
        activeStatus:0,
        setting: {
          autoplay: false,
          autoplaySpeed: 2000,
          dots: 'inside',
          radiusDot: false,
          trigger: 'click',
          arrow: 'hover'
        },
        indexdata:{
          home_introduce:'',//首页的医院简介
          home_introduce_pic:'',//医院简介封面图
          home_notice_pic:'',//首页图-医院通知
          home_news_pic:'',//首页图-重大新闻
          home_message_pic:'',//首页图-信息公告
          home_culture_pic:'',//首页图-医院文化
          home_room_pic:'',//首页图-科室介绍"
        },
        culturelist:[],
        banner:[],
        notice:[],
        news:[],
        message:[],
        department:[],
        departmentList:[],
        departmentActive:0,
      };
    },
    created() {
      this.getData();
      this.getCulture();
      this.getBanner();
      this.getNotice();
      this.getNews();
      this.getMessage();
      this.getDepartment();
    },
    methods: {
      activeClick(num){
        let self = this;
        if(num == self.activeStatus){
          self.activeStatus = 0;
        }else{
          self.activeStatus = num;
        }

      },
      /*获取基础配置*/
      getData() {
        let self = this;
        IndexApi.base(true)
          .then(res => {
            self.loading = false;
            var list = res.data;
            for (let i=0;i<list.length;i++){
              if(list[i].dictParentKey=='home_introduce'){
                self.indexdata.home_introduce = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_introduce_pic'){
                self.indexdata.home_introduce_pic = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_notice_pic'){
                self.indexdata.home_notice_pic = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_news_pic'){
                self.indexdata.home_news_pic = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_message_pic'){
                self.indexdata.home_message_pic = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_culture_pic'){
                self.indexdata.home_culture_pic = list[i].dictName;
              }
              if(list[i].dictParentKey=='home_room_pic'){
                self.indexdata.home_room_pic = list[i].dictName;
              }
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      getCulture() {
        let self = this;
        IndexApi.culturelist(true)
          .then(res => {
            self.loading = false;
            self.culturelist = res.data;

          })
          .catch(error => {
            self.loading = false;
          });
      },
      getBanner() {
        let self = this;
        IndexApi.banner(true)
          .then(res => {
            self.loading = false;
            self.banner = res.data;

          })
          .catch(error => {
            self.loading = false;
          });
      },
      getNotice() {
        let self = this;

        let Params = {};
        Params.page = 1;
        Params.limit = 3;
        IndexApi.notice(Params,true)
          .then(res => {
            self.loading = false;
            self.notice = res.data.list;

          })
          .catch(error => {
            self.loading = false;
          });
      },
      getNews() {
        let self = this;

        let Params = {};
        Params.page = 1;
        Params.limit = 3;
        IndexApi.news(Params,true)
          .then(res => {
            self.loading = false;
            self.news = res.data.list;

          })
          .catch(error => {
            self.loading = false;
          });
      },
      getMessage() {
        let self = this;

        let Params = {};
        Params.page = 1;
        Params.limit = 3;
        IndexApi.message(Params,true)
          .then(res => {
            self.loading = false;
            self.message = res.data.list;

          })
          .catch(error => {
            self.loading = false;
          });
      },
      getDepartment() {
        let self = this;

        let Params = {};
        Params.page = 1;
        Params.limit = 3;
        IndexApi.department(Params,true)
          .then(res => {
            self.loading = false;
            self.department = res.data.list;

          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style lang="scss" scoped>

  #news{
    width:1180px;margin:42px auto 0;display: flex;justify-content: space-between;
    .news_item{
      width:530px;box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);
      .news_item_dl{
        padding:0 38px 9px;
        .news_item_dt{
          display: flex;justify-content: space-between;padding:10px 0 13px;
          .news_item_dt_title{
            height:42px;line-height: 42px;font-size: 30px;line-height: 42px;
          }
          .news_item_dt_more{
            a{
              height:32px;padding:5px 17px;border-radius: 30px;border: 1px solid #DEDEDE;line-height: 20px;font-size:16px;color:#999;
            }
          }
        }
        dd{
          height:52px;line-height: 52px;overflow: hidden;text-overflow: ellipsis;position: relative;
          a{
            font-size:16px;color:#333;
          }
        }
        dd::before{
          position: absolute;content: '';left:0;bottom:0;right:0;height:1px;background: #DEDEDE;
        }
        dd:last-child::before{background: none;}
      }
    }
  }
  #about{

    .index_about{
      width:1180px;margin:0 auto;
      .index_about_title{
        margin:50px 0;height:50px;line-height: 50px;font-size:36px;color:#333333;
      }
      .index_about_content{
        height: 634px;display: flex;justify-content: space-between;
        .index_about_content_img{
          flex: 1;
        }
        .index_about_content_text{
          flex: 1;
          height: 520px;
          padding:0 0 0 40px;color: #333333;line-height: 41px;letter-spacing: 3px;font-size: 28px;text-indent: 2em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 13;
        }
      }
    }
  }
  #culture{
    margin:40px 0 0 0;
    .index_culture{
      width:1180px;margin:0 auto;
      .index_culture_title{
        margin:40px 0 30px;font-size:36px;color:#333;height:50px;line-height: 50px;
      }
      .index_culture_list{
        display: flex;justify-content: space-between;
        .index_culture_list_item{
          width:294px;height:464px;text-align: center;box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.25);position: relative;
          .index_culture_list_item_ba{
            position: absolute;left:0;top:0;right:0;bottom:0;
            display: none;
          }
          .index_culture_list_item_title{
            height:42px;line-height: 42px;font-size:30px;color:#333;margin:80px 0 0 0;
          }
          .index_culture_list_item_image_line{
            margin:70px auto 140px;
          }
          .index_culture_list_item_image_activeline{
            position: relative;margin:48px 48px 70px;height:2px;background: #fff;display: none;
          }
          .index_culture_list_item_image_activeline::before{
            position: absolute;content: '';left:20px;bottom:0;height:2px;width:50px;background: #007E4F;
          }
          .index_culture_list_item_bottom_text{display: none;padding:0 60px 0 80px;font-size:28px;line-height: 45px;color:#FFFFFF;letter-spacing: 3px;text-shadow: 0px 4px 4px rgba(0,0,0,0.8);}
          .index_culture_list_item_image_bottom{
            margin:0 auto;
          }
        }
        .index_culture_list_item.active{
          width:696px;background: rgba(0,0,0,0.4);
          .index_culture_list_item_ba{display: block;}
          .index_culture_list_item_image_line{display: none;}
          .index_culture_list_item_image_bottom{display: none;}
          .index_culture_list_item_image_activeline{display: block;}
          .index_culture_list_item_bottom_text{display: block;}
        }
        .index_culture_list_item:hover{
          background: rgba(0,126,79,0.1);cursor: pointer;
        }
        .index_culture_list_item.active:hover{
          background: rgba(0,0,0,0.4);cursor: pointer;
        }
      }
    }
  }
  #department{
    width:1180px;margin:0 auto;
    .department_title{
      margin:40px 0;height:50px;line-height: 50px;font-size:36px;color:#333;
    }
    .department_info{
      display: flex;justify-content: space-between;
      .department_list{
        flex: 1;padding: 20px 0 0 58px;
        .department_list_tab{
          display: flex;justify-content: space-between;
          .department_list_tab_item{
            position: relative;
            p{padding:10px 30px;border-radius: 10px;height:60px;line-height: 40px;cursor: pointer;position: relative;box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);z-index: 10;}
            /*p::before{
              position: absolute;content: '';left:50%;bottom: -15px;margin-left:-15px;height:30px;
              width:30px;background: #fff;border: 1px solid #DEDEDE;z-index: 8;transform: rotate(90deg);-webkit-transform: rotate(90deg);
            }*/
            span{padding:10px 30px;display: block;cursor: pointer;}
            .department_list_tab_item_downimg{
              display: none;position: absolute;left:50%;bottom:-26px;margin-left:-16px;z-index: 100;
            }
          }
          .department_list_tab_item.active{
            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.50);
            .department_list_tab_item_downimg{
              display: block;
            }
          }
        }
        .department_list_content{
          margin:15px 0 0 0;overflow: hidden;height:380px;
          p{
            margin:20px 20px 0 0;cursor: pointer;
            display: inline-block;border:1px solid #ccc;border-radius: 5px;
            span.department_list_content_text{
              display: block;padding:9px 36px;height:46px;float:left;line-height: 28px;
            }
            span.department_list_content_right{
              font-size:20px;color:#999;display:block;padding:12px 8px;border-left:1px solid #ccc;
              height:46px;float:right;line-height: 28px;
            }
          }
          p:hover{color:#007E4F;}

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue